import { useContext, useEffect, useState } from "react";
import { fetchData, GET_CARPOOL_BY_CATEGORY_ID } from "../../components/Service";
import moment from "../../../node_modules/moment/moment";
import { Link, useLocation, useNavigate, useParams } from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";
import { Context } from "../../components/Context";
import { toast } from "react-toastify";

const Carpool = (props) => {
	const navigate = useNavigate();
	const { carpool_id } = useParams();
	const location = useLocation();
	const [context, setContext] = useContext(Context);
	const [list, setList] = useState([]);
	const [pageUrl, setPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);

	const getList = (carpoolId) => {
		let payload = {
			category_id: carpoolId,
		};
		fetchData(pageUrl ? pageUrl : GET_CARPOOL_BY_CATEGORY_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	useEffect(() => {
		scrollTop();
		if (carpool_id) {
			setPageUrl();
			getList(carpool_id);
		}
	}, [carpool_id]);

	useEffect(() => {
		scrollTop();
		if (carpool_id) {
			getList(carpool_id);
		}
	}, [pageUrl]);

	const createCarpool = () => {
		if (context?.userToken) {
			navigate(`/carpool/create/${carpool_id}`, { state: { email: "hello, I'm an email" } });
		} else {
			setContext((prev) => ({
				...prev,
				loginLocation: navigate(`/carpool/create/${carpool_id}`),
			}));
			window.$("#loginModal").modal("show");
		}
	};
	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 className="text-white d-flex mb-0 py-2">{location?.state?.pageTitle} Carpool</h4>
							</div>
							<div className="col-lg-9 ms-auto text-start text-lg-end ">
								<button className="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px" onClick={createCarpool}>
									Create Carpool
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="card-body bg-white p-1 body-minh">
				<div className="table-responsive">
					<table className="table table-striped">
						<thead>
							<tr className="table-active">
								<th scope="col">{carpool_id == 1 ? "From City" : carpool_id == 2 ? "From State" : "From Country"}</th>
								<th scope="col">{carpool_id == 1 ? "To City" : carpool_id == 2 ? "To State" : "To Country"}</th>
								<th scope="col">Start Date</th>
								<th scope="col">Start Time</th>
							</tr>
						</thead>
						<tbody>
							{list?.data &&
								list?.data?.length > 0 &&
								list?.data?.map((item) => (
									<tr key={item.id}>
										<td>
											<Link to={`/carpool/details/${item.id}`} state={{ carpool: item }}>
												{carpool_id == 1 ? (
													<>
														{item?.from_city?.name ?? "N/A"}, {item?.from_city?.state_code ?? "N/A"}
													</>
												) : carpool_id == 2 ? (
													<>{item?.from_state?.name ?? "N/A"}</>
												) : (
													<>{item?.from_country?.name ?? "N/A"}</>
												)}
											</Link>
										</td>
										<td>
											<Link to={`/carpool/details/${item.id}`} state={{ carpool: item }}>
												{carpool_id == 1 ? (
													<>
														{item?.to_city?.name ?? "N/A"}, {item?.to_city?.state_code ?? "N/A"}
													</>
												) : carpool_id == 2 ? (
													<>{item?.to_state?.name ?? "N/A"}</>
												) : (
													<>{item?.to_country?.name ?? "N/A"}</>
												)}
											</Link>
										</td>
										<td>{item.start_date ? moment(item.start_date).format("DD-MMM-YYYY") : "N/A"}</td>
										<td>{item?.start_time ? moment(item.start_time, "HH:mm:ss").format("hh:mm A") : "N/A"}</td>
									</tr>
								))}

							{notFound && (
								<tr>
									<td className="text-center h6 text-danger py-3" colSpan={4}>
										No Records Found!
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				{list?.data && (
					<nav className="pt-3">
						<ul className="pagination justify-content-end">
							<li className={`page-item ${list.prev_page_url ? "" : "disabled"}`}>
								<button type="button" className="page-link" onClick={() => setPageUrl(list.prev_page_url)}>
									<span aria-hidden="true">&laquo;</span> Previous
								</button>
							</li>
							<li className={`page-item ${list.next_page_url ? "" : "disabled"}`}>
								<button type="button" className="page-link" onClick={() => setPageUrl(list.next_page_url)}>
									Next <span aria-hidden="true">&raquo;</span>
								</button>
							</li>
						</ul>
					</nav>
				)}
			</div>
		</div>
	);
};

export default Carpool;
